import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateVersionsFetchFailedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateVersionsFetchFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSIONS_FETCH_FAILED',
	payload,
});
